<template>
  <div class="col-6 col-lg-3 mb-4 mb-lg-0">
    <div class="card mb-4">
      <img
        :src="`${series.image}?w=350`"
        class="card-img-top"
        :alt="series.title"
        loading="lazy"
      >
      <div class="card-body">
        <h5 class="card-title">
          {{ title }}
        </h5>

        <p
          v-if="summary"
          class="card-text"
          v-html="summary"
        />

        <p class="d-none">
          {{ translationLanguageCodes }}
        </p>

        <p
          v-if="! hasTranslation"
          class="text-danger mb-0"
        >
          {{ $t('series.notAvailableInLanguage') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { chain, find, kebabCase } from "lodash";

export default {
  name: "SeriesItem",

  props: {
    series: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return {
      find,
    }
  },

  computed: {
    title() {
      const locale = this.$i18n.locale;

      const translation = find(this.series.translations, (row) => (row.language.code.toLowerCase() === locale.toLowerCase()));

      return (translation ? translation.content : this.series.title);
    },

    summary() {
      const locale = this.$i18n.locale;

      const translation = find(this.series.summary_translations, (row) => (row.language.code.toLowerCase() === locale.toLowerCase()));

      return (translation ? translation.content : this.series.summary);
    },

    translationLanguageCodes() {
      return chain(this.series.languages)
        .map("code")
        .map(kebabCase)
        .value();
    },

    hasTranslation() {
      return this.translationLanguageCodes.includes(this.$app.locale.toLowerCase());
    },
  },
};
</script>
